import React, { useCallback, useMemo, useEffect, useState } from "react";

import imageExtensions from "image-extensions";
import isUrl from "is-url";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { createEditor, Editor, Transforms } from "slate";
import { withHistory } from "slate-history";
import {
  Slate,
  Editable,
  useSelected,
  useFocused,
  withReact,
  ReactEditor
} from "slate-react";

import TextEditorFunctionsMenu from "./TextEditorFunctionsMenu/TextEditorFunctionsMenu";
import TextEditorInsertingModal from "./TextEditorInsertingModal/TextEditorInsertingModal";
import URL$1 from "../../config/api";
import axios from "../../config/axios";

import "./styles.css";

const TextEditor = props => {
  const [imageImporter, setImageImporter] = useState(false);
  const [itemMenuFocus, setItemMenuFocus] = useState(false);
  const user = useSelector(state => state.user);

  const userId = user.user.id;

  //* **IMAGEM*****************************************************************************/

  const withImages = editor => {
    const { insertData, isVoid } = editor;

    editor.isVoid = element =>
      element.type === "image" ? true : isVoid(element);

    editor.insertData = async data => {
      const text = data.getData("text/plain");
      const { files } = data;

      if (files && files.length > 0) {
        const imageURL = await uploadPasteImage(files[0]);
        insertImage(editor, imageURL);
      } else {
        insertData(data);
      }
    };

    return editor;
  };

  const uploadPasteImage = async file => {
    const formData = new FormData();
    formData.append("file0", file);

    try {
      const imageUploadResponse = await axios.post(
        `${URL$1.api}file/question_images/${userId}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      return URL$1.img + imageUploadResponse.data.files[0].url;
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar imagem");
    }
  };

  const insertImage = (editor, src) => {
    const text = { text: "" };
    const image = { type: "image", url: src, children: [text] };
    Transforms.insertNodes(editor, image);

    const lineBreak = { type: "paragraph", children: [text] };
    Transforms.insertNodes(editor, lineBreak);
  };

  const isImageUrl = url => {
    if (!url) return false;
    if (!isUrl(url)) return false;
    const ext = new URL(url).pathname.split(".").pop();
    return imageExtensions.includes(ext);
  };

  let ImageElement = ({ attributes, children, element }) => {
    const selected = useSelected();
    const focused = useFocused();
    return (
      <div {...attributes}>
        <div contentEditable={false}>
          <img
            alt=""
            src={element.url}
            className="d-block rounded"
            style={{
              maxWidth: "100%",
              maxHeight: "20em",
              boxShadow: selected && focused ? "0 0 0 3px #B4D5FF" : "none"
            }}
          />
        </div>
        {children}
      </div>
    );
  };

  //* **IMAGEM*****************************************************************************/

  //* **DADOS*****************************************************************************/

  const editorData = editorId => {
    switch (editorId) {
      // description
      case 1:
        return {
          containerClass: "description-text-editor-container",
          textBoxClass: "description-text-box",
          placeholder: "Descreva sua questão"
        };
      // feedback
      case 2:
        return {
          containerClass: "feedback-text-editor-container",
          textBoxClass: "feedback-text-box",
          placeholder: "Dê um feedback para sua questão"
        };
      // item
      case 3:
        return {
          containerClass: "item-text-editor-container",
          textBoxClass: "item-text-box",
          placeholder: "Novo item"
        };
      // answer
      case 4:
        return {
          containerClass: "answer-text-editor-container",
          textBoxClass: "answer-text-box",
          placeholder: "Escreva sua resposta"
        };

      default:
        return {
          containerClass: "description-text-editor-container",
          textBoxClass: "description-text-box",
          placeholder: "Descreva sua questão"
        };
    }
  };

  useEffect(() => {
    switch (props.editorType.id) {
      /* case 1:
          if (JSON.parse(localStorage.getItem(`question-${props.questionId}-description`))) {
            setValue(JSON.parse(localStorage.getItem(`question-${props.questionId}-description`)))
          } else if (JSON.parse(props.textContent)) {
            setValue(JSON.parse(props.textContent));
          }
        break;

      case 2:
          if (JSON.parse(localStorage.getItem(`question-${props.questionId}-feedback`))) {
            setValue(JSON.parse(localStorage.getItem(`question-${props.questionId}-feedback`)))
          } else if (JSON.parse(props.textContent)) {
            setValue(JSON.parse(props.textContent));
          }
        break;

      case 3:
          if (JSON.parse(localStorage.getItem(`question-${props.questionId}-option-${props.itemIndex}`))) {
            setValue(JSON.parse(localStorage.getItem(`question-${props.questionId}-option-${props.itemIndex}`)))
          } else if (JSON.parse(props.textContent)) {
            setValue(JSON.parse(props.textContent));
          }
        break;

      case 4:
          if (JSON.parse(localStorage.getItem(`question-${props.questionId}-answer`))) {
            setValue(JSON.parse(localStorage.getItem(`question-${props.questionId}-answer`)))
          } else if (JSON.parse(props.textContent)) {
            setValue(JSON.parse(props.textContent));
          }
        break; */

      default:
        if (JSON.parse(props.textContent)) {
          setValue(prevValue => JSON.parse(props.textContent));
        }
        break;
    }
  }, [
    props.editorType.id,
    props.itemIndex,
    props.questionId,
    props.textContent
  ]);

  //* **DADOS*****************************************************************************/

  //* **FORMATAÇÃO*****************************************************************************/

  const toggleMark = (e, editor, format) => {
    e.preventDefault();

    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  const isMarkActive = (editor, format) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  let Leaf = ({ attributes, children, leaf }) => {
    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }

    if (leaf.italic) {
      children = <em>{children}</em>;
    }

    if (leaf.underline) {
      children = <u>{children}</u>;
    }

    return <span {...attributes}>{children}</span>;
  };

  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  let Element = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return <ImageElement {...props} />;
      default:
        return <div {...attributes}>{children}</div>;
    }
  };

  const renderElement = props => <Element {...props} />;

  //* **FORMATAÇÃO*****************************************************************************/

  //* **MODAL*****************************************************************************/

  const showImageImporterModal = () => {
    setImageImporter(true);
  };

  const hideImageImporterModal = () => {
    setImageImporter(false);
  };

  //* **MODAL*****************************************************************************/

  //* **RENDER*****************************************************************************/
  const editor = useMemo(
    () => withImages(withHistory(withReact(createEditor()))),
    []
  );
  const [value, setValue] = useState([
    {
      type: "paragraph",
      children: [{ text: "" }]
    }
  ]);
  const handleNewItem = () => {
    const newNode = { type: "paragraph", children: [{ text: "" }] };
    Transforms.insertNodes(editor, newNode);
    const path = [editor.children.length - 1];
    Transforms.select(editor, Editor.end(editor, path));
    ReactEditor.focus(editor);
  };
  const handleNewItemLocal = () => {
    // Só cria novo bloco se não houver conteúdo
    if (Editor.string(editor, []) === "") {
      const newNode = { type: "paragraph", children: [{ text: "" }] };
      Transforms.insertNodes(editor, newNode);
      const path = [editor.children.length - 1];
      Transforms.select(editor, Editor.end(editor, path));
    }

    ReactEditor.focus(editor);

    // Mantém o comportamento original do props
    if (props.handleNewItem) {
      props.handleNewItem();
    }
  };

  return (
    <div className={editorData(props.editorType.id).containerClass}>
      <Slate
        editor={editor}
        value={value}
        onChange={newValue => {
          switch (props.editorType.id) {
            case 1:
              props.changeQuestionDescription(newValue);
              break;

            case 2:
              props.changeQuestionFeedback(newValue);
              break;

            case 3:
              props.itemDescriptionChanger(props.itemIndex, newValue);
              break;

            case 4:
              props.changeQuestionTextAnswer(newValue);
              break;

            default:
              break;
          }

          setValue(newValue);
        }}
      >
        {!props.readOnly && (
          <TextEditorInsertingModal
            userId={userId}
            insertImage={insertImage}
            editorAcces={editor}
            show={imageImporter}
            hideImageImporter={hideImageImporterModal}
          />
        )}
        <Editable
          className={editorData(props.editorType.id).textBoxClass}
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          readOnly={props.readOnly}
          placeholder={editorData(props.editorType.id).placeholder}
          onFocus={() => {
            if (props.editorType.id === 3 && props.newItem) {
              // Apenas foca e seleciona o último bloco
              const path = [editor.children.length - 1];
              Transforms.select(editor, Editor.end(editor, path));
              ReactEditor.focus(editor);

              // Chama o handle do menu, mas sem criar nó extra
              if (props.handleNewItem) {
                props.handleNewItem();
              }
            }
          }}
          onKeyDown={event => {
            if (
              props.editorType.id === 3 &&
              event.key === "Enter" &&
              !event.shiftKey
            ) {
              event.preventDefault();
              handleNewItemLocal();
            }
          }}
        />
      </Slate>
      {!props.newItem && !props.readOnly && (
        <TextEditorFunctionsMenu
          itemMode={props.editorType.id === 3}
          showItemMenu={!props.readOnly}
          editorAcces={editor}
          toggleMark={toggleMark}
          showImageImporter={showImageImporterModal}
        />
      )}
    </div>
  );
};

//* **RENDER*****************************************************************************/

export default TextEditor;
